<template>
  <div class="addMaterialy">
    <el-dialog :title="title || '新增材料'" :visible.sync="addMaterialyVisible" width="90%" :show-close="true">
      <div class="content flex h-100 bg-f3f4f7">
        <div id="moveLeftM" class="h-100 flex-column bg-ff menu" style="width: 200px">
          <div class="left-top">
            <div class="flex-1 font-16-30313a">材料分类</div>
          </div>
          <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
            <cate-menu :menu-data="classifyList" :special-item="1" @on-choose="onChooseMenu" :choose-id="chooseMenuId"
              :not-operate="true"></cate-menu>
          </div>
        </div>
        <move-horizon moveId="moveLeftM"></move-horizon>
        <div class="flex-1 flex-column w-0 ptb-10 pr-20">
          <div class="flex mb-10">
            <div class="title flex align-center bg-ff flex-1">
              <div class="decoration-line mr-5"></div>
              <div class="font-16-46b8b0 font-bold">{{ currentClassify.name }}</div>
            </div>
            <div class="flex ml-10">
              <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
                <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
                <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable
                  @keyup.enter.native="searchBtn(1)"></el-input>
              </div>
              <button class="btn-30-bg-46b8b0" @click="searchBtn(1)">搜索</button>
            </div>
          </div>
          <div class="flex mb-10">
            <div class="flex align-center cursor mr-20" v-for="(item, index) in options" :key="index"
              @click="selectOption(index)">
              <img class="mr-5"
                :src="customs[index].visible ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'"
                alt="">
              <div class="font-12-ff5555">{{ item.name }}</div>
            </div>
            <div class="flex-1 flex justify-end">
              <div class="flex align-center cursor mr-20" v-for="(item, index) in rebateList" :key="index"
                @click="selectRebate(index)">
                <img class="mr-5"
                  :src="rebateIndex == index ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'"
                  alt="">
                <div class="font-12-ff5555">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="flex-1 flex-column h-0">
            <div class="flex-1 h-0 flex-column">
              <div class="flex-1 h-0">
                <erp-table ref="erpTable" @change-current-row="changeCurrentRow" @on-choose="onChooseMaterial"
                  :table-data="tableData" :loading="loading" @on-dbl-click="onChooseMaterial" :customs="customs"
                  :column-data="columnData"></erp-table>
              </div>
              <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
              </Pagination>
            </div>
            <move-vertical :max="560" :min="100" moveDom="bottom" moveId="moveTopM"></move-vertical>
            <div id="moveTopM" class="flex-column" style="height: 200px">
              <div class="flex align-center">
                <div class="flex align-center mr-20 cursor pb-5 relative"
                  :class="{ 'tabActive': index === smallTabIndex }" v-for="(item, index) in smallTab" :key="index"
                  @click="switchSmallTab(index)">
                  <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
                  <div class="font-bold" :class="index === smallTabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}
                  </div>
                </div>
              </div>
              <div class="hr mb-20" style="margin-top: -1px;"></div>
              <div class="overflow-y flex-1">
                <div class="text-left font-12-30313a h-100" v-if="smallTabIndex === 0">
                  <div>{{ currentRow.description }}</div>
                </div>
                <div class="text-left flex h-100" v-if="smallTabIndex === 1">
                  <div v-for="(item, index) in currentRow.materialPhotoList" :key="index" class="mr-10"
                    style="width: 90px">
                    <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList"
                      fit="cover"></el-image>
                    <div class="font-12-30313a text-center w-100 text-overflow">{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import CateMenu from '../../../components/CateMenu'
import MoveHorizon from '../../../components/MoveHorizon'
import MoveVertical from '../../../components/MoveVertical'
import Pagination from '@/components/Pagination'
export default {
  name: 'AddMaterialy',
  components: { ErpTable, CateMenu, MoveHorizon, MoveVertical, Pagination },
  props: ['title', 'budgetType', 'budgetId', 'budgetRoomId', 'define', 'replaceId', 'isGive', 'status'],
  data () {
    return {
      keywords: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      addMaterialyVisible: false,
      chooseMenuId: 0,
      classifyList: [],
      smallTab: ['材料说明', '相关图片'],
      smallTabIndex: 0,
      currentClassify: {},
      options: [],
      loading: true,
      tableData: [],
      currentRow: {},
      columnData: [
        {
          field: 'operate',
          title: '操作',
          width: '65',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '选择',
            methodName: 'on-choose'
          }]
        }, {
          field: 'specialItem',
          title: '特项',
          width: '55'
        }, {
          field: 'code',
          title: '材料编码',
          width: '100'
        }, {
          field: 'name',
          title: '材料名称',
          minWidth: '180'
        }, {
          field: 'brand',
          title: '品牌名',
          width: '130'
        }, {
          field: 'standard',
          title: '规格',
          width: '80'
        }, {
          field: 'model',
          title: '型号',
          width: '120'
        }, {
          field: 'colorNumber',
          title: '色号',
          width: '100'
        }, {
          field: 'purchasingUnit',
          title: '采购单位',
          width: '100'
        }, {
          field: 'salesUnit',
          title: '销售单位',
          width: '100'
        }
      ],
      srcList: [],
      customs: [],
      priceIndex: 0,
      priceList: {},
      isClassifyShow: true,
      permission: [],
      rebateIndex: -1,
      rebateList: [
        {
          name: '正价返点',
          flag: 'positive'
        },
        {
          name: '优惠价返点',
          flag: 'discount'
        },
        {
          name: '特价返点',
          flag: 'special'
        },
        {
          name: '自由返点',
          flag: 'free'
        }
      ]
    }
  },
  created () {
    this.getClassify()
    this.getPermission()
    this.axios.post('materialPrice/list', { companyId: this.$store.state.companyId, isAvailability: true }).then(res => {
      if (res.data.success) {
        if (res.data.data.length > 0) {
          this.options = res.data.data
          this.priceList = this.options[0]
          for (let i = 0; i < this.options.length; i++) {
            this.columnData.push({
              field: this.options[i].customerPriceField,
              title: this.options[i].name,
              width: '100'
            })
            this.customs.push({
              field: this.options[i].customerPriceField,
              visible: i === 0
            })
          }
          if (this.permission.includes('checkComputation')) {
            this.columnData.push({
              field: this.options[0].costPriceField,
              title: this.options[0].costPriceName,
              width: '100'
            })
            this.columnData.push({
              field: 'businessName',
              title: '供应商',
              width: '200'
            })
          }
          this.getMaterial()
        }
      }
    })
  },
  mounted () {
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    onChooseMaterial (data) {
      if (this.budgetType === 1) { // 1客户预算
        this.$emit('add-material', data, this.options.length > this.priceIndex ? this.options[this.priceIndex] : {}, this.rebateIndex > -1 ? this.rebateList[this.rebateIndex].flag : '')
        // this.addMaterialyVisible = false
      } else {
        this.$emit('choose-material', data, this.options.length > this.priceIndex ? this.options[this.priceIndex] : {})
        this.addMaterialyVisible = false
      }
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getMaterial()
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.getMaterial()
      }
    },
    getMaterial (isRefresh) {
      this.tableData = []
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        status: 1,
        priceFlag: 1,
        companyId: this.$store.state.companyId
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenuId
      }
      if (this.options.length > 0) {
        params.priceType = this.options[this.priceIndex].customerPriceField
      }
      this.axios.post(`material/queryForPage`, params).then(res => {
        this.loading = false
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (this.tableData.length > 0) {
            this.currentRow = this.tableData[0]
            this.srcList = []
            if (this.currentRow.materialPhotoList) {
              for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
                this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
              }
            }
          }
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`materialClassify/findAllClassify`, { companyId: this.$store.state.companyId, status: 1, priceFlag: 1 }).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getMaterial()
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.srcList = []
      for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
        this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
      }
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    searchBtn (a) {
      this.page = 1
      this.isClassifyShow = false
      this.chooseMenuId = 0
      this.getClassify()
      this.getMaterial()
    },
    selectOption (index) {
      let customs = []
      this.customs.forEach(i => {
        customs.push({
          field: i.field,
          visible: false
        })
      })
      customs[index].visible = true
      this.customs = customs
      this.priceIndex = index
      this.priceList = this.options[index]
      this.getMaterial()
    },
    selectRebate (index) {
      this.rebateIndex = index
      // this.getMaterial()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getMaterial()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addMaterialy /deep/ .el-dialog {
  height: 80%;
  display: flex;
  flex-direction: column;
}

.addMaterialy /deep/ .el-dialog__body {
  flex: 1;
  min-height: 0;
  height: 0;
}

.button {
  border: solid 1px #e2e2e2;
  border-radius: 4px;
  cursor: pointer;
}

.menu {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.hide-x {
  box-shadow: none !important;
}

.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  font-weight: bold;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.content .title {
  height: 30px;
  padding-left: 10px;
  border-radius: 4px;
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/enterRoomItem/AddMaterialy.vue